import { queryOptions, useQuery } from '@tanstack/react-query'

import reportApi from 'api/reportApi'
import Utils from 'general/utils/Utils'

import _ from 'lodash'

const generalReportQueries = {
  base: {
    scope: ['report', 'generalReport'],
  },

  all: () => ({
    ...generalReportQueries.base,

    entity: ['invoicesByTax'],
  }),

  getList: (params) =>
    queryOptions({
      queryKey: [generalReportQueries.all(), params],

      queryFn: ({ signal }) => reportApi.getReportBytax(params, signal),

      staleTime: 1000 * 30,
    }),
}

export const useQueryGeneralReport = (filters, sysConfig) => {
  return useQuery({
    ...generalReportQueries.getList(filters),
    select: (res) => {
      let totalTaxMoney = 0
      let totalBeforeTax = 0
      try {
        let dataGeneralReport = res?.data?.taxArray ?? []
        for (let index = 0; index < dataGeneralReport.length; index++) {
          const generalReport = dataGeneralReport[index]
          const invoiceProducts = generalReport?.invoiceProducts ?? []
          for (let indexIP = 0; indexIP < invoiceProducts.length; indexIP++) {
            const invoiceProduct = invoiceProducts?.[indexIP]
            totalTaxMoney =
              totalTaxMoney +
              Number(
                Utils.formatNumber(
                  invoiceProduct?.taxMoney,
                  sysConfig.totalCost,
                )
                  ?.toString()
                  .replace(/\./g, '')
                  .replace(',', '.'),
              )
            totalBeforeTax =
              totalBeforeTax +
              Number(
                Utils.formatNumber(
                  invoiceProduct?.totalUnitPrice,
                  sysConfig.totalCost,
                )
                  ?.toString()
                  .replace(/\./g, '')
                  .replace(',', '.'),
              )
          }
        }
        console.log('totalBeforeTax', totalBeforeTax)
      } catch (error) {
        console.log('error', error)
      }
      console.log('data', totalTaxMoney)
      // Utils.formatNumber(item?.totalUnitPrice, sysConfig.totalCost)

      return {
        invoicesByTax: _.get(res, 'data.taxArray', []),

        totalRevenueBeforeTax: totalBeforeTax,
        // _.get(res, totalBeforeTax, 0),

        totalTax: totalTaxMoney,

        totalRevenueAfterTax: totalTaxMoney + totalBeforeTax,
      }
    },
  })
}
